<template>
  <div class="invoiceBox" v-if="invoiceInfo">
    <!-- 顶部返回 -->
    <el-button
      type="text"
      class="invoiceBox_back"
      icon="el-icon-arrow-left"
      @click="$router.go(-1)"
      >返回</el-button
    >
    <!-- 主体box -->
    <div class="invoiceBox_main">
      <!-- 顶部导航栏 -->
      <div class="mainBox_title">发票详情</div>

      <div class="mainBox_infoCardHead">
        您的发票申请分1张发票开具，开票总额<span style="color: #f10203"
          >¥{{ invoiceInfo.allInvoicePrice.toFixed(2) }}</span
        >
        <el-link
          v-if="
            invoiceInfo.orderInvoiceInfos[0].acceptType == 0 &&
            invoiceInfo.orderInvoiceInfos[0].status == 1
          "
          v-for="(item, index) in invoiceInfo.invoicePathList"
          :key="index"
          type="primary"
          class="mainBox_infoCardBtn"
          :href="item"
          >下载发票{{ index + 1 }}<i class="el-icon-download"></i
        ></el-link>
        <el-link
          v-if="
            invoiceInfo.orderInvoiceInfos[0].acceptType == 0 &&
            invoiceInfo.orderInvoiceInfos[0].status == 2
          "
          type="primary"
          class="mainBox_infoCardBtn"
          @click="failing()"
          >下载发票</el-link
        >
      </div>
      <table border="1" bordercolor="#ddd" class="mainBox_table">
        <col width="424px" padding-left="15px" />
        <tr>
          <td>
            发票性质：<span style="color: #f89a00">{{
              invoiceInfo.orderInvoiceInfos[0].acceptType == 0
                ? "电子发票"
                : "纸质发票（请联系区域客服经理尽快开票）"
            }}</span>
          </td>
          <td>
            发票状态：<span style="color: #f89a00">{{
              invoiceInfo.orderInvoiceInfos[0].acceptType == 0
                ? invoiceInfo.orderInvoiceInfos[0].status == 0
                  ? "开票失败"
                  : invoiceInfo.orderInvoiceInfos[0].status == 1
                  ? "已开具"
                  : "开票中"
                : invoiceInfo.orderInvoiceInfos[0].status == 1
                ? "已邮寄"
                : "开票中"
            }}</span>
          </td>
        </tr>
        <tr>
          <td>
            发票类型：{{
              invoiceInfo.orderInvoiceInfos[0].invoiceType == 0
                ? "增值税普通发票"
                : "增值税专用发票"
            }}
          </td>
          <td>申请抬头：{{ invoiceInfo.orderInvoiceInfos[0].companyName }}</td>
        </tr>
        <tr>
          <td>
            申请时间：{{ getDate(invoiceInfo.orderInvoiceInfos[0].createTime) }}
          </td>
          <td>发票编号：{{ invoiceInfo.orderInvoiceInfos[0].fpdm }}</td>
        </tr>
        <tr v-if="invoiceInfo.orderInvoiceInfos[0].acceptType == 1">
          <td>收件人：{{ invoiceInfo.orderInvoiceInfos[0].pickName }}</td>
          <td>收取地址：{{ invoiceInfo.orderInvoiceInfos[0].sendAddress }}</td>
        </tr>
        <tr v-if="invoiceInfo.orderInvoiceInfos[0].acceptType == 1">
          <!-- <td>收取邮编：{{invoiceInfo.}}</td> -->
          <td>联系电话：{{ invoiceInfo.orderInvoiceInfos[0].pickPhone }}</td>
          <td>
            物流公司：{{ invoiceInfo.orderInvoiceInfos[0].expressCompany }}
          </td>
        </tr>
        <tr v-if="invoiceInfo.orderInvoiceInfos[0].acceptType == 1">
          <td>
            物流单号：{{ invoiceInfo.orderInvoiceInfos[0].expressNumber }}
          </td>
        </tr>
        <tr v-if="invoiceInfo.orderInvoiceInfos.length > 1">
          <td colspan="2">开票方式：合并开票</td>
        </tr>
        <tr>
          <td colspan="2">
            备注：{{ invoiceInfo.orderInvoiceInfos[0].remark }}
          </td>
        </tr>
      </table>
    </div>
    <div
      class="invoiceBox_main"
      style="margin-top: 27px"
      v-for="(it, idx) in invoiceInfo.orderInvoiceInfos"
      :key="idx"
    >
      <div class="invoiceBox_mainHead">
        {{ getDate(it.createTime) }}
        <span style="margin-left: 30px">订单号：{{ it.ordersn }}</span>
      </div>
      <!-- 表头 -->
      <div class="mainBox_titleBox">
        <div style="width: 460px">商品</div>
        <div style="width: 160px">单位</div>
        <div style="width: 224px">数量</div>
        <div style="width: 230px">总计</div>
      </div>

      <!-- 商品列表 -->

      <div
        class="mainBox_orderList"
        v-for="(item, index) in it.orderGoods"
        :key="index"
      >
        <div class="orderList_main">
          <img
            :src="item.goodsThumb"
            alt=""
            class="orderList_img"
            @click="gotoDetails(item.goodsId)"
          />
          <div class="orderList_mainTitle">
            <span style="margin-bottom: 8px"> {{ item.title }}</span>
            <span style="color: #969696; font-size: 16px">
              {{ item.spec }}</span
            >
          </div>
          <span style="width: 160px" class="mainSpan">{{ item.unit }}</span>
          <div style="width: 224px; text-align: center">x{{ item.total }}</div>
          <div style="width: 230px; color: #ff4019">
            ¥{{ item.realPrice.toFixed(2) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { doGet } from "../../common/HttpHelper.js";
import { httpConfig } from "../../common/config.js";
export default {
  data() {
    return {
      invoiceInfo: "", //发票信息
    };
  },
  mounted() {
    this.getData(this.$route.query.id);
  },

  methods: {
    /**
     * 时间格式化（补0）
     */
    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    /**
     * 时间戳转换
     */
    getDate(time) {
      if (!time) return "";
      if (time == typeof string) {
        var reg = getRegExp("-", "g"); // 获取正则表达式，全局替换
        time = time.replace(reg, "/");
      }
      var date = new Date(time);
      var M = date.getMonth() + 1;
      var y = date.getFullYear();
      var d = date.getDate();
      var h = date.getHours();
      var mm = date.getMinutes();
      var s = date.getSeconds();
      if (M < 10) M = "0" + M;
      if (d < 10) d = "0" + d;
      return (
        y +
        "." +
        M +
        "." +
        d +
        " " +
        this.add0(h) +
        ":" +
        this.add0(mm) +
        ":" +
        this.add0(s)
      );
    },
    /**
     * 商品详情
     */
    gotoDetails(id) {
      this.$router.push({ path: "/goodsInfo", query: { id: id } });
    },
    /**
     * 获取发票信息
     */

    getData(id) {
      var that = this;
      var data = {
        id: id,
      };
      doGet(
        httpConfig.myInvoice.getInvoiceDetailsUrl,
        data,
        function (res) {
          if (res.flag) {
            that.invoiceInfo = res.data;
          } else {
            that.$message.warning(res.message);
          }
        },
        function (res) {}
      );
    },
    /**
     * 开票失败或者开票中
     */
    failing() {
      this.$message.warning("开票中，请耐心等待");
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/personal/invoiceDetails";
</style>



// WEBPACK FOOTER //
// src/components/page/personal/invoiceDetails.vue